import React from "react";

const Fld = ({ label, children }) => (
  <div>
    <label className="ahp-lbl">{label}</label>
    {children}
  </div>
);

export default Fld;
